import '@expo/metro-runtime';
import React, { lazy, Suspense } from 'react';
import { usePreventPageZoom } from 'src/hooks/usePreventPageZoom';
import { TRouteComponent } from './_shared/routes.types';
import { PageLoader } from '@photosi/rn-components/page-loader/PageLoader';
import { BottomSheetProvider } from '@photosi/rn-components/bottom-sheet-provider/BottomSheetProvider';
import { GoogleOneTapLogin } from '@photosi/rn-components/google-one-tap-login/GoogleOneTapLogin';

const EditorV3 = lazy(() => import('src/screen/editor-v3/EditorV3'));

export const EditorNewRoute: TRouteComponent = () => {
  usePreventPageZoom();

  return (
    <Suspense fallback={<PageLoader />}>
      <BottomSheetProvider>
        <EditorV3 />
      </BottomSheetProvider>
      {/* <GoogleOneTapLogin /> */}
    </Suspense>
  );
};
